import { render, staticRenderFns } from "./VuePell.vue?vue&type=template&id=58f95f20&"
import script from "./VuePell.vue?vue&type=script&lang=js&"
export * from "./VuePell.vue?vue&type=script&lang=js&"
import style0 from "./VuePell.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports